module.exports = __webpack_public_path__ + "img/copy-icon.2b8fa2bb.svg";